import { Zone } from "./zone";
import { MeasurementViewModel } from "./measurement-view-model";
import { Property } from "./property";
import { DeviceTypeViewModel } from "./device-type-view-model";


export class Location {
	id: string;
	name: string;
	code: string;
	description: string;
	gpsCoordinates: any;
	timeZone: string;
	signalRGroup: string;
	zones: Array<Zone>;
	currentMeasurements: Array<MeasurementViewModel>;
	deployedDeviceTypes: Array<DeviceTypeViewModel>;
	properties: any;
	deviceTypeIds: Array<string>;
	hasCurtainControllers: boolean;
}